export default __webpack_public_path__ + "fbb4792384a53fd973b355a1742e29dc.woff2";